import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  startObserveFileMetaDataUpdates,
  stopObserveFileMetaDataUpdates,
} from 'modules/websocket/actions/fileMetaDataUpdates';
import { getCurrentConsultationMedia } from '../../actions/getCurrentConsultationMedia';
import { getUploadInstructions } from '../../actions/getUploadInstructions';

import { retryUploadMedia } from '../../actions/retryUploadConsultationMedia';
import { deleteConsultationMediaWithConfirm } from '../../actions/deleteConsultationMedia';
import { editFileMetadataParametersWithConfirm } from '../../actions/editFileMetaDataParameters';
import {
  getFilesTotal,
  getViews,
  getUploads,
  getAllowedActions,
  isCurrentAppointmentArchived,
} from '../../selectors/mediaGallery';

import MediaGallery from './MediaGallery';
import { fetchMediaData } from './utils';

const mapStateToProps = state => {
  const { appointmentId } = state.appointmentInfo.currentAppointment;
  const { status, uploadInstructionsStatus, uploadInstructions } = state.appointmentInfo.patientMedia;

  return {
    status,
    filesTotal: getFilesTotal(state),
    views: getViews(state),
    uploads: getUploads(state),
    allowedActions: getAllowedActions(state),
    isArchived: isCurrentAppointmentArchived(state),
    appointmentId,
    fetchMediaData,
    stopObserveFileMetaDataUpdates,
    uploadInstructionsStatus,
    uploadInstructions,
  };
};

const mapDispatchToProps = {
  getCurrentConsultationMedia,
  getUploadInstructions,
  startObserveFileMetaDataUpdates,
  deleteConsultationMediaWithConfirm,
  editFileMetadataParametersWithConfirm,
  retryUploadMedia,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MediaGallery));

